// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xyhebqsgccwvmigqkwam.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh5aGVicXNnY2N3dm1pZ3Frd2FtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0ODE5NTcsImV4cCI6MjA2MTA1Nzk1N30.bG3eqx5JHo48opNR-R1ePHdFlm1t1-V8Cj7M8N9Xm94";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);